import React from 'react';
import {
  Box, ContentContainer, FDStat, Stack,
} from '@facet-wealth/design';
import Title from 'Components/ComponentLibrary/Atoms/Text/Title';
import Subtitle from 'Components/ComponentLibrary/Atoms/Text/Subtitle';
import RichTextDisplay from 'Components/UI/Overrides/RichTextDisplay';
import MetaField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import PropTypes from 'prop-types';
import fr from 'facet-rest';

const FundingInstructionsPageTemplateContent = ({ resource }) => {
  return (
    <Box margin={400}>
      <ContentContainer maxWidth={'xs'}>
        <Stack direction={'column'} alignItems={'center'} spacing={3} justifyContent="space-between">

          <Stack direction={'column'} alignItems={'center'} spacing={3} justifyContent="flex-start">
            <Title text={resource.attr('title')} test="wizard-step-title" />
            <Subtitle
              text={resource.attr('subtitle')}
              test="wizard-step-subtitle"
            />
            <FDStat label={'Amount'} value={resource.attr('amount')} />
            <RichTextDisplay content={resource.attr('additionalInstructions')} />
          </Stack>
          <Box>
            <MetaField attr="consent" />
          </Box>
        </Stack>
      </ContentContainer>
    </Box>
  );
};

FundingInstructionsPageTemplateContent.defaultProps = {
};

FundingInstructionsPageTemplateContent.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};

export default FundingInstructionsPageTemplateContent;
